import React, { useEffect, useState } from 'react';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function MemberProgress() {
  const [photos, setPhotos]   = useState([]);
  const [angle, setAngle]     = useState('front');
  const [file, setFile]       = useState(null);
  const [weight, setWeight]   = useState('');
  const [notes, setNotes]     = useState('');
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState('');

  const load = () => axios.get('/member/progress-photos').then(r => setPhotos(r.data));
  useEffect(() => { load(); }, []);

  const upload = async e => {
    e.preventDefault();
    if (!file) { setMsg('Please select a photo.'); return; }
    setSaving(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('photo', file); fd.append('angle', angle);
      if (weight) fd.append('weight', weight);
      if (notes) fd.append('notes', notes);
      await axios.post('/member/progress-photos', fd, { headers:{ 'Content-Type':'multipart/form-data' } });
      setMsg('Photo saved!'); setFile(null); setWeight(''); setNotes(''); load();
    } catch (err) { setMsg(err.response?.data?.message || 'Error uploading.'); }
    finally { setSaving(false); }
  };

  const remove = async id => { await axios.delete(`/member/progress-photos/${id}`); load(); };

  const byAngle = a => photos.filter(p => p.angle === a);

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">Progress photos</h1><p className="page-sub">{photos.length} photos uploaded</p></div></div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 2fr', gap:18 }}>
        {/* Upload panel */}
        <div className="card">
          <div className="card-header"><div className="card-title">📸 Upload photo</div></div>
          <form onSubmit={upload} style={{ padding:18 }}>
            {msg && <div style={{ marginBottom:12, padding:'9px 14px', borderRadius:'var(--radius)', background: msg.includes('!') ? 'var(--success-dim)' : 'var(--danger-dim)', color: msg.includes('!') ? 'var(--success)' : 'var(--danger)', fontSize:13 }}>{msg}</div>}

            <div className="form-group">
              <label className="label">Angle</label>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:6 }}>
                {['front','side','back'].map(a => (
                  <button type="button" key={a} onClick={() => setAngle(a)} style={{ padding:'8px 4px', background: angle===a ? 'var(--accent-dim)' : 'var(--surface-2)', border:`1px solid ${angle===a ? 'var(--accent-border)' : 'var(--border)'}`, borderRadius:'var(--radius)', color: angle===a ? 'var(--accent)' : 'var(--text-secondary)', fontSize:12, fontWeight:500, cursor:'pointer', textTransform:'capitalize' }}>
                    {a === 'front' ? '⬆️' : a === 'side' ? '➡️' : '⬇️'} {a}
                  </button>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label className="label">Photo *</label>
              <div style={{ border:'1.5px dashed var(--border-strong)', borderRadius:'var(--radius-lg)', padding:'20px', textAlign:'center', cursor:'pointer', position:'relative' }}
                onClick={() => document.getElementById('prog-file').click()}>
                {file ? (
                  <div>
                    <img src={URL.createObjectURL(file)} alt="" style={{ maxHeight:120, borderRadius:8, marginBottom:8 }} />
                    <div style={{ fontSize:12, color:'var(--text-muted)' }}>{file.name}</div>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>📁</div>
                    <div style={{ fontSize:13, color:'var(--text-secondary)' }}>Tap to select photo</div>
                    <div style={{ fontSize:11, color:'var(--text-muted)' }}>JPG, PNG, HEIC up to 20 MB</div>
                  </div>
                )}
                <input id="prog-file" type="file" accept="image/*" style={{ display:'none' }} onChange={e => setFile(e.target.files[0])} />
              </div>
            </div>

            <div className="form-group"><label className="label">Weight (kg) — optional</label><input className="input" type="number" step="0.1" placeholder="e.g. 78.5" value={weight} onChange={e => setWeight(e.target.value)} /></div>
            <div className="form-group"><label className="label">Notes — optional</label><input className="input" placeholder="How are you feeling?" value={notes} onChange={e => setNotes(e.target.value)} /></div>
            <button className="btn-primary" type="submit" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving ? 'Uploading…' : 'Save photo'}</button>
          </form>
        </div>

        {/* Gallery */}
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {['front','side','back'].map(a => (
            <div key={a} className="card">
              <div className="card-header"><div className="card-title" style={{ textTransform:'capitalize' }}>{a === 'front' ? '⬆️' : a === 'side' ? '➡️' : '⬇️'} {a} view ({byAngle(a).length})</div></div>
              {byAngle(a).length === 0 ? (
                <div style={{ padding:'16px 18px', fontSize:13, color:'var(--text-muted)' }}>No {a} view photos yet.</div>
              ) : (
                <div style={{ display:'flex', flexWrap:'wrap', gap:10, padding:14 }}>
                  {byAngle(a).map(p => (
                    <div key={p.id} style={{ position:'relative', width:100 }}>
                      <img src={`${API_URL}${p.photo_url}`} alt="" style={{ width:100, height:100, objectFit:'cover', borderRadius:'var(--radius)', border:'1px solid var(--border)' }} />
                      <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'rgba(0,0,0,.6)', borderRadius:'0 0 var(--radius) var(--radius)', padding:'4px 6px', fontSize:10, color:'white' }}>
                        {new Date(p.date).toLocaleDateString('en-GB', { day:'2-digit', month:'short' })}
                        {p.weight && <span> · {p.weight}kg</span>}
                      </div>
                      <button onClick={() => remove(p.id)} style={{ position:'absolute', top:4, right:4, width:20, height:20, borderRadius:'50%', background:'rgba(0,0,0,.6)', border:'none', color:'white', fontSize:11, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
